import { useMemo } from "react"
import { Box, ToggleButton, ToggleButtonGroup, useTheme } from "@mui/material"
import { Link } from "react-router-dom"
import { capitalize } from "lodash"

import { getIcon } from "utils/icon"
import { useTranslation } from "providers/i18n"
import { usePromotion } from "hooks/promotion/usePromotion"

import { PageLayout } from "layouts/PageLayout"

import { PromotionCard } from "components/domains/promotions"
import { Head } from "components/Head"
import { EmptyData } from "components/EmptyData"
import { PercentIcon } from "components/icons"

export const Promotions = ({ Layout = PageLayout, AppNavigation }) => {
  const { t } = useTranslation()
  const { groupPromotions, activeGroupPromotion, handleChange, promotions } =
    usePromotion()
  const activePromotions = groupPromotions[activeGroupPromotion]

  const theme = useTheme()

  const emptyIcon = useMemo(
    () => getIcon(theme?.assets?.empty?.promotions) || <PercentIcon />,
    [theme]
  )

  const { styleOverrides } = theme.components?.[`PromotionPage`] || {}
  const {
    root,
    pageLayout,
    promotionGroupSelectorButton,
    toggleButtonGroup,
    toggleButton,
    gridContainer,
    emptyDataWrapper,
  } = styleOverrides || {}

  //Todo: refactor code to config layout by appConfig
  const { promotionSeparatedOption } =
    theme.components?.[`PromotionPage`]?.defaultProps || {}

  return (
    <>
      <Head title={t("Promotions")} />
      <Layout sx={pageLayout} AppNavigation={AppNavigation}>
        <Box sx={root}>
          {promotionSeparatedOption ? (
            <>
              <Box sx={promotionGroupSelectorButton}>
                <ToggleButtonGroup
                  value={activeGroupPromotion}
                  onChange={handleChange}
                  exclusive
                  sx={toggleButtonGroup}
                >
                  <ToggleButton value="current" sx={toggleButton}>
                    {t("Current Promotions")}
                  </ToggleButton>
                  <ToggleButton value="upcoming" sx={toggleButton}>
                    {t("Upcoming Promotions")}
                  </ToggleButton>
                </ToggleButtonGroup>
              </Box>
              {activePromotions && activePromotions.length > 0 ? (
                <Box sx={gridContainer}>
                  {activePromotions.map((promotion) => {
                    const sponsoredId = promotion?.properties?.sponsoredId
                    return (
                      <Link
                        to={`/promotions/${promotion.id}`}
                        key={`${sponsoredId || ""}${promotion.id}`}
                      >
                        <PromotionCard promotion={promotion} />
                      </Link>
                    )
                  })}
                </Box>
              ) : (
                <Box sx={emptyDataWrapper}>
                  <EmptyData
                    icon={emptyIcon}
                    primary={t(
                      `No ${capitalize(activeGroupPromotion)} Promotions`
                    )}
                    secondary={t("Check Back Soon")}
                  />
                </Box>
              )}
            </>
          ) : (
            <>
              {promotions && promotions.length > 0 ? (
                <Box sx={gridContainer}>
                  {promotions.map((promotion) => {
                    const sponsoredId = promotion?.properties?.sponsoredId
                    return (
                      <Link
                        to={`/promotions/${promotion.id}`}
                        key={`${sponsoredId || ""}${promotion.id}`}
                      >
                        <PromotionCard promotion={promotion} />
                      </Link>
                    )
                  })}
                </Box>
              ) : (
                <Box sx={emptyDataWrapper}>
                  <EmptyData
                    icon={emptyIcon}
                    primary={t(`Coming soon`)}
                    secondary={t("Stay tuned for the update")}
                  />
                </Box>
              )}
            </>
          )}
        </Box>
      </Layout>
    </>
  )
}
